import request from '@utils/request'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async settingStore({
    commit
  }, query) {
    await request.post('/admin/deposit/setting/store', query)

  },
  async fetchList({
    commit
  }, query) {
    const {
      items,
      pagination
    } = await request.post('/admin/deposit/search', query)
    return {
      items,
      total: pagination?.total || 0
    }
  },
  async fetchListAll({
    commit
  }, { memberId }) {
    const {
      items
    } = await request.post('/admin/deposit/search', { paginate: 0, member_id: memberId })
    return {
      items,
    }
  },
  async store({
    commit
  }, query) {
    let data = {
      ...query
    }
    // data.startDate='fwsgewga'
    await request.post('/admin/deposit/store', data)

    // const resault = await request.post('/admin/deposit/store',data)
    // console.log(resault)
    // return resault
  },
  async fetchSingle({
    commit
  }, id) {
    const {
      items
    } = await request.get(`/admin/deposit/${id}`)
    return items
  },
  async uploadImages({
    commit
  }, query) {
    await request.post('/admin/deposit/media/upload', query)
  },
  async orderStore({
    commit
  }, query) {
    const { items } = await request.post('/admin/order/store', query)
    return items
  },
  async fetchOrderList({
    commit
  }, query) {
    const { items, pagination } = await request.post('/admin/deposit/order/search', query)
    return {
      items,
      total: pagination?.total || 0
    }
  },
  async fetchHistoryList({
    commit
  }, query) {
    const { items, pagination } = await request.post('/admin/merchant/member/deposit/history/search', query)
    return {
      items,
      total: pagination?.total || 0
    }
  },
  async fetchSingleOrder({
    commit
  }, id) {
    const {
      items
    } = await request.get(`/admin/deposit/order/${id}`)
    return items
  },
  async withdraw({
    commit
  }, query) {
    await request.post('/admin/merchant/member/deposit/withdraw', query)
  },
  async updateState({
    commit
  }, submitData) {
    await request.post('/admin/deposit/state', submitData)
  },
  async export({
    commit
  }, exportParams) {
    const { items } = await request
      .post('/admin/deposit/order/export', exportParams)
    return items
  },
}